<template>
  <div class="loader__container" id="loader">
    <img class="loader" src="@/assets/logoWhite.svg" alt="" />
  </div>
</template>

<script>
export default {
  name: 'Loader',
}
</script>
